import layout from "src/styles/layout.module.scss";
import { InView } from "react-intersection-observer";
import { PopularBrands } from "src/organisms/PopularBrands";
import { Wrapper } from "./PopularBrands.styled";
import type { ProductListType } from "src/types/product-listing";
import { LISTING_PAGE_NAME } from "src/utils/constants";

type PopularBrandsWrapperProps = {
  localeGenderId: string;
  genderId: string;
  excludeSlug?: string;
  viewAllLink?: string;
  productListType?: ProductListType;
};

function PopularBrandsWrapper({
  localeGenderId,
  genderId,
  excludeSlug,
  viewAllLink,
  productListType,
}: PopularBrandsWrapperProps): React.ReactElement {
  const pageType = productListType
    ? `${LISTING_PAGE_NAME[productListType]}_`
    : "";

  return (
    <InView rootMargin={"100px 0px 0px 0px"}>
      {({ inView, ref }) => (
        <Wrapper ref={ref} className={layout.bleedMobile}>
          {inView && genderId && (
            <PopularBrands
              localeGenderId={localeGenderId}
              genderId={genderId as "women" | "men" | "kids"}
              excludeSlug={excludeSlug}
              viewAllLink={viewAllLink}
              pageName={`${pageType}product_listing_page`}
            />
          )}
        </Wrapper>
      )}
    </InView>
  );
}

export { PopularBrandsWrapper };
